import { useEntitiesServiceEntitiesVehicleBrandsListKey } from '@insurance/api/queries'
import { EntitiesService, Vehicle } from '@insurance/api/requests'
import { InfiniteSelect } from '@shared/components'
import { capitalize } from '@shared/utils'
import { SelectProps } from 'antd'

type Props = {
  vehicleValue?: Vehicle
} & SelectProps

export const EditVehicleBrandSelect = ({
  vehicleValue: _,
  ...props
}: Props) => {
  return (
    <InfiniteSelect
      apiCall={({ search, pageParam, pageSize }) =>
        EntitiesService.entitiesVehicleBrandsList(
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[useEntitiesServiceEntitiesVehicleBrandsListKey]}
      getOption={(data) => ({
        //TODO use Id instead of name when api is done
        value: data?.name,
        label: capitalize(data?.name)
      })}
      {...props}
    />
  )
}
